/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC30lEQVR4nMVVW2sTURAOqFWr1jsKIiJ4o3+hagQthmbPmWngZGZ7IZXaKoqvgvpgC17io/4LQauiiKAFRZ/qFW/4YKuIVvBBW2sRxBuzO5ssJmlSX3pgYXd2znzffDNnTiIxk8s5t9gi7zdIAwb5jUWetEjfLPKIBb4I4O9Lpdob/idwnQHuN8BjFvnPVI9B+mKRj8uemoIb49YbpAfFAHzT2uweY9wG59x8eeQ9sMm/CAx4qCXTtm7K4AC01gK9DQIDvzaZbFNVQplsk/gq0Eg67daUdUylUnMt8DNlcy/StsW51Qb4hAV+Ivob4AmD9CiQ0PAq8bHWLrJAd1Wyx729vXNKmQD1qSSvouC2ldzUdaDPBikTEmxvkL1qP1bSLcLMIv/20N+qcpEB+qWsrgDQDgkCkFtibXaXBb6uUv6MQEQuiSGknHMLCwAe+AdCaWiwIAvyVw1wuJL+0j3qM5ZybmVgAxrUDHuK8iANhI7UpU6ntBaXNcM6i3TGAI0apA8WOR+1pUG6oXv7VOouJXs+BsDvxIhIm3TT08DJZrcr03yZGuRDKbO7lcxD+U5n/I0KMBxPdVKMzc0dCzSD7/LteV69shotAQD+qNkt08KOFzpKGyDeQT/EKIcoDhABqiz/ZvA+DiA1C+rpefVal4liBkDDoSRuc1wiD2hnJYkM8OlyEnkZf4v+fxkD4KtaqG4NeDLY1MoHi0XmvGRSUmTgQxqwPwT096pEF+ISdUdzR74RO5cb5CPpdNvSRJUlPgboqEil5G5p9p0Fp1BHGo93TrSSyeRsHWx3LPCn8KHbBjkn/+K+ALQtmrAlY1xYqExnI5vn+Svik7VMJw1FzEP2dK7i4UzmcvNER2tdY8RchloN98F959yssEVdoxw4GZzVpBUte6oFL3ZUOAGmtQzQtVoBLNKl6QMggU7YKuyD+8GbNoAsGbkGuUMYGuQXYTCZsvQ8vPSpLTrtM7b+AkUEI3fOcCCwAAAAAElFTkSuQmCC)
 */
export const StageIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.61 18.25a1.08 1.08 0 0 1-.07-1.33 9 9 0 1 0-15.07 0c.26.42.25.97-.08 1.33l-.02.02c-.41.44-1.12.43-1.46-.07a11 11 0 1 1 18.17 0c-.33.5-1.04.51-1.45.07l-.02-.02Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.83 15.23c.43.47 1.18.42 1.45-.14a7 7 0 1 0-12.57 0c.28.56 1.03.6 1.46.14l.05-.06c.3-.33.35-.81.17-1.23A4.98 4.98 0 0 1 12 7a5 5 0 0 1 4.6 6.94c-.17.42-.13.9.18 1.23l.05.06Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.33 20.03c-.25.72.12 1.5.8 1.84a10.96 10.96 0 0 0 9.73 0 1.52 1.52 0 0 0 .8-1.84 6 6 0 0 0-11.33 0Z"
        className={colorClass}
      />
    </svg>
  );
};
